import _regenerator from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "vant/es/notify/style";
import _Notify from "vant/es/notify";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "vant/es/dialog/style";
import _Dialog from "vant/es/dialog";
import _objectSpread from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.string.trim.js";
import _ from 'lodash';
import { mapGetters } from 'vuex';
import AiInput from '@/components/ai-input/index.vue';
import AiWin from './ai-win.vue';
import { getSessionStorage, getToken, removeSessionStorage, setSessionStorage, setToken } from '@/utils/storage';
import * as aiApi from '@/api/ai';
import { createUniqueString, isJsonString } from '@/utils';
import Adviser from '@/views/compliance/home/adviser/index.vue';
import { getRecommendLaw } from '@/api/law';
import { md } from '@/utils/markdown';
export default {
  components: {
    AiWin: AiWin,
    AiInput: AiInput,
    Adviser: Adviser
  },
  data: function data() {
    return {
      hasBizToken: false,
      // 是否有token
      showOverlay: false,
      // 遮罩层
      thinkingFlowTemplate: [{
        title: '开始',
        icon: 'start',
        elapsedTime: '',
        createdAt: ''
      }, {
        title: '知识库检索',
        icon: 'library',
        elapsedTime: '',
        createdAt: ''
      }, {
        title: '实时联网检索',
        icon: 'earth',
        elapsedTime: '',
        createdAt: ''
      }, {
        title: '政策法规库检索',
        icon: 'celue',
        elapsedTime: '',
        createdAt: ''
      }, {
        title: '深度分析',
        icon: 'policy-thinking',
        elapsedTime: '',
        createdAt: ''
      }],
      // 思考流程模板
      autoScroll: true,
      // 自动滚动
      historyPagination: {
        // 历史回话分页数据
        size: 1000,
        current: 1
      },
      chunk: [],
      chatTemplate: {
        question: {
          id: '',
          person: 'admin',
          content: ''
        },
        answer: {
          id: '',
          person: 'mechanical',
          list: []
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['userInfo'])), mapGetters('ai', ['topBarHeight', 'guideQuestionList', 'aiChatList', 'aiLoading', 'qaId', 'reloadHandler', 'sendHandler'])), {}, {
    height: function height() {
      return "calc(100vh - ".concat(this.topBarHeight + 150, "px)");
    }
  }),
  watch: {
    'sendHandler.send': {
      handler: function handler(val) {
        if (val) {
          this.sendMessage(this.sendHandler.message);
          this.$store.dispatch('ai/setValue', {
            key: 'sendHandler',
            value: {
              send: false,
              message: ''
            }
          });
        }
      },
      immediate: true
    },
    'reloadHandler.isReload': {
      handler: function handler(val) {
        if (val) {
          this.reloadAnswer(this.reloadHandler.data);
          this.$store.dispatch('ai/setValue', {
            key: 'reloadHandler',
            value: {
              isReload: false,
              data: {}
            }
          });
        }
      }
    },
    aiLoading: {
      handler: function handler(newVal, oldVal) {
        var _this = this;
        if (!newVal) {
          setTimeout(function () {
            if (_this.autoScroll) {
              _this.scrollToBottom();
            }
          }, 300);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.hasBizToken = !!getToken(); // 判断是否有业务token,注意：是业务token，不是AI token

    this.getAiToken();
    var winId = getSessionStorage('windowId');
    if (winId) {
      this.$store.dispatch('ai/setValue', {
        key: 'windowId',
        value: winId
      });
      this.getHistoryConversationRecord(winId);
    }
    this.$eventBus.$on('auto-scroll', function () {
      if (_this2.aiLoading && _this2.autoScroll) {
        _this2.scrollToBottom();
      }
    });
    this.$eventBus.$on('get-conversation-record', function (windowId) {
      _this2.getHistoryConversationRecord(windowId);
    });
    this.$eventBus.$on('new-conversation', function () {
      _this2.initWindow();
      _this2.$store.dispatch('ai/reset');
    });
  },
  methods: {
    /**
     * 获取token,默认用户，如果登录用登录的用户ID及用户名
     */
    getAiToken: function getAiToken() {
      var _this3 = this;
      var applyId = process.env.VUE_APP_COMPLIANCE_APPLY_ID;
      var spaceId = process.env.VUE_APP_COMPLIANCE_SPACE_ID;
      var query = {
        applyId: applyId,
        spaceId: spaceId,
        userId: this.userInfo.id || 'default',
        userName: this.userInfo.phone || 'default'
      };
      aiApi.getUserToken(query).then(function (_ref) {
        var data = _ref.data;
        setToken(data, 'ai-token');
        _this3.initWindow();
      });
    },
    /**
     * 初始化窗口
     */
    initWindow: function initWindow() {
      var _this4 = this;
      aiApi.initChatWindow().then(function (_ref2) {
        var data = _ref2.data;
        var windowId = data.windowId,
          presetQuestionList = data.presetQuestionList;
        setSessionStorage('windowId', windowId);
        removeSessionStorage('conversationId');
        _this4.$store.dispatch('ai/setValue', {
          key: 'windowId',
          value: windowId
        });
        _this4.$store.dispatch('ai/setValue', {
          key: 'guideQuestionList',
          value: presetQuestionList
        });
      });
    },
    /**
     * 获取新windowId的会话历史
     */
    getHistoryConversationRecord: function getHistoryConversationRecord(windowId) {
      var _this5 = this;
      this.showOverlay = true;
      aiApi.getOneConversationRecord({
        current: 1,
        size: 100,
        windowId: windowId
      }).then(function (_ref3) {
        var data = _ref3.data;
        var aiChatList = data.records.reverse().map(function (item) {
          var template = _.cloneDeep(_this5.chatTemplate);
          var qaId = createUniqueString();
          template.question = {
            person: 'admin',
            id: qaId,
            content: item.question
          };
          template.answer = {
            person: 'mechanical',
            id: qaId,
            list: []
          };
          var alogList = item.alogList;
          template.answer.list = alogList.map(function (log) {
            var obj = {
              aLogId: '',
              // 答案ID
              qLogId: '',
              // 问题ID
              content: '',
              // 内容
              help: 0,
              // 1无用,10有用,0初始状态
              windowId: '',
              conversationId: '',
              webQueryList: [],
              // 联网查询结果(博查)
              webQueryLoading: false,
              // 联网查询请求状态
              lawQueryList: [],
              // 法规查询结果
              LawQueryLoading: false,
              // 法规查询请求状态
              libraryQueryList: [],
              // 知识库查询结果 （目前没有实际业务,仅为占位）
              libraryQueryLoading: false,
              // 知识库查询请求状态
              thinkingFlow: [],
              // 思考工作流
              referDocList: [],
              // 推荐文档
              evaluate: 0 // 点赞、点踩
            };
            obj.aLogId = log.alogId;
            obj.qLogId = log.qlogId;
            obj.content = log.answer;
            obj.evaluate = log.evaluate;
            obj.referDocList = item['cardLogList'] || [];
            obj.webQueryList = item['webSearchList'] || [];
            obj.lawQueryList = item['libraryApiList'] || [];
            return obj;
          });
          return template;
        });
        _this5.$store.dispatch('ai/setValue', {
          key: 'windowId',
          value: windowId
        });
        _this5.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: aiChatList
        });
        _this5.scrollToBottom();
      }).finally(function (_) {
        _this5.showOverlay = false;
      });
    },
    /**
     * 鼠标滚动
     * @param event
     */
    wheelEvent: function wheelEvent(event) {
      if (event.deltaY < 0) {
        // 向上滚动
        this.autoScroll = false;
      } else {
        this.autoScroll = !!this.scrollAtBottom();
      }
    },
    /**
     * 是否滚动到底部
     * @return {boolean}
     */
    scrollAtBottom: function scrollAtBottom() {
      var _this$$refs$scrollWi = this.$refs['scroll-win-ref'],
        scrollHeight = _this$$refs$scrollWi.scrollHeight,
        clientHeight = _this$$refs$scrollWi.clientHeight,
        scrollTop = _this$$refs$scrollWi.scrollTop;
      return scrollTop + clientHeight >= scrollHeight - 1;
    },
    /**
     * 滚动到底部
     */
    scrollToBottom: function scrollToBottom() {
      var _this6 = this;
      this.$nextTick(function () {
        _this6.$refs['scroll-win-ref'].scrollTop = _this6.$refs['scroll-win-ref'].scrollHeight;
      });
    },
    /**
     * 发送
     * @param content
     */
    sendMessage: function sendMessage(content) {
      var _this7 = this;
      var token = getToken();
      if (!token) {
        _Dialog.confirm({
          title: '提示',
          message: '请先登录',
          confirmButtonText: '登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          try {
            // 重定向到登录界面
            wx.miniProgram.navigateTo({
              url: '/pagesLogin/login/index'
            });

            // 向小程序传递的数据，但只会在特定的事件被小程序的@message事件中获取
            // (后退，分享，组件销毁)
            // wx.miniProgram.postMessage({ data: {}})
          } catch (e) {
            _Toast.fail(e);
          }
        }).catch(function () {});
      } else {
        if (this.aiLoading) {
          _Notify({
            message: '正在输出,请稍后再试~',
            color: '#333',
            background: '#f8db63'
          });
          return;
        }
        var aiChatList = _.cloneDeep(this.aiChatList);
        var chatTemplate = _.cloneDeep(this.chatTemplate);
        var qaId = createUniqueString();
        // 生成当前操作ID
        this.$store.dispatch('ai/setValue', {
          key: 'qaId',
          value: qaId
        });
        chatTemplate.question.id = qaId;
        chatTemplate.answer.id = qaId;
        chatTemplate.question.content = content;
        chatTemplate.answer.list.push({
          aLogId: '',
          // 答案ID
          qLogId: '',
          // 问题ID
          content: '',
          // 内容
          help: 0,
          // 1无用,10有用,0初始状态
          windowId: '',
          conversationId: '',
          webQueryList: [],
          // 联网查询结果(博查)
          webQueryLoading: false,
          // 联网查询请求状态
          lawQueryList: [],
          // 法规查询结果
          LawQueryLoading: false,
          // 法规查询请求状态
          libraryQueryList: [],
          // 知识库查询结果 （目前没有实际业务,仅为占位）
          libraryQueryLoading: false,
          // 知识库查询请求状态
          thinkingFlow: [],
          // 思考工作流
          referDocList: [],
          // 推荐文档
          evaluate: 0 // 点赞、点踩
        });
        aiChatList.push(chatTemplate);
        this.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: aiChatList
        });
        this.$store.dispatch('ai/setValue', {
          key: 'aiLoading',
          value: true
        });
        this.getWebQueryList(aiChatList, content).finally(function (_) {
          _this7.getLawQueryList(aiChatList, content).finally(function (_) {
            _this7.getStreamMessage(content);
          });
        });
      }
    },
    /**
     * 博查联网查询
     */
    getWebQueryList: function getWebQueryList(aiChatList, content) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, new Promise(function (resolve, reject) {
                var lastAnswerIndex = aiChatList[aiChatList.length - 1]['answer']['list'].length - 1;
                aiChatList[aiChatList.length - 1]['answer']['list'][lastAnswerIndex]['webQueryLoading'] = true;
                _this8.$store.dispatch('ai/setValue', {
                  key: 'aiChatList',
                  value: aiChatList
                });
                aiApi.webQuery({
                  count: 50,
                  page: 1,
                  query: content,
                  searchType: 'AUTHORITY'
                }).then(/*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref4) {
                    var data;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          data = _ref4.data;
                          _context.n = 1;
                          return _this8.loopSetWebQuery(aiChatList, 0, data);
                        case 1:
                          resolve(data);
                        case 2:
                          return _context.a(2);
                      }
                    }, _callee);
                  }));
                  return function (_x) {
                    return _ref5.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  reject(error);
                });
              }));
          }
        }, _callee2);
      }))();
    },
    /**
     * 模拟动态加载博查
     */
    loopSetWebQuery: function loopSetWebQuery(aiChatList) {
      var _arguments = arguments,
        _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var dataIndex, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              dataIndex = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 0;
              data = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : [];
              return _context4.a(2, new Promise(function (resolve) {
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
                  var lastAnswerIndex;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        lastAnswerIndex = aiChatList[aiChatList.length - 1]['answer']['list'].length - 1;
                        aiChatList[aiChatList.length - 1]['answer']['list'][lastAnswerIndex]['webQueryList'] = data.filter(function (item, index) {
                          return index <= dataIndex;
                        });
                        _context3.n = 1;
                        return _this9.$store.dispatch('ai/setValue', {
                          key: 'aiChatList',
                          value: aiChatList
                        });
                      case 1:
                        if (!(dataIndex < data.length - 1)) {
                          _context3.n = 3;
                          break;
                        }
                        _context3.n = 2;
                        return _this9.loopSetWebQuery(aiChatList, dataIndex + 1, data);
                      case 2:
                        _context3.n = 4;
                        break;
                      case 3:
                        // eslint-disable-next-line require-atomic-updates
                        aiChatList[aiChatList.length - 1]['answer']['list'][lastAnswerIndex]['webQueryLoading'] = false; // 停止博查检索标识
                        _context3.n = 4;
                        return _this9.$store.dispatch('ai/setValue', {
                          key: 'aiChatList',
                          value: aiChatList
                        });
                      case 4:
                        resolve(true);
                      case 5:
                        return _context3.a(2);
                    }
                  }, _callee3);
                })), 100);
              }));
          }
        }, _callee4);
      }))();
    },
    /**
     * 模拟动态加载法规
     */
    loopSetLawQuery: function loopSetLawQuery(aiChatList) {
      var _arguments2 = arguments,
        _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var dataIndex, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              dataIndex = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : 0;
              data = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : [];
              return _context6.a(2, new Promise(function (resolve) {
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
                  var lastAnswerIndex;
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        lastAnswerIndex = aiChatList[aiChatList.length - 1]['answer']['list'].length - 1;
                        aiChatList[aiChatList.length - 1]['answer']['list'][lastAnswerIndex]['lawQueryList'] = data.filter(function (item, index) {
                          return index <= dataIndex;
                        });
                        _context5.n = 1;
                        return _this0.$store.dispatch('ai/setValue', {
                          key: 'aiChatList',
                          value: aiChatList
                        });
                      case 1:
                        if (!(dataIndex < data.length - 1)) {
                          _context5.n = 3;
                          break;
                        }
                        _context5.n = 2;
                        return _this0.loopSetLawQuery(aiChatList, dataIndex + 1, data);
                      case 2:
                        _context5.n = 4;
                        break;
                      case 3:
                        // eslint-disable-next-line require-atomic-updates
                        aiChatList[aiChatList.length - 1]['answer']['list'][lastAnswerIndex]['lawQueryLoading'] = false; // 停止博查检索标识
                        _context5.n = 4;
                        return _this0.$store.dispatch('ai/setValue', {
                          key: 'aiChatList',
                          value: aiChatList
                        });
                      case 4:
                        resolve(true);
                      case 5:
                        return _context5.a(2);
                    }
                  }, _callee5);
                })), 100);
              }));
          }
        }, _callee6);
      }))();
    },
    /**
     * 法规联网搜索
     */
    getLawQueryList: function getLawQueryList(aiChatList, content) {
      var _this1 = this;
      return new Promise(function (resolve, reject) {
        var lastAnswerIndex = aiChatList[aiChatList.length - 1]['answer']['list'].length - 1;
        aiChatList[aiChatList.length - 1]['answer']['list'][lastAnswerIndex]['lawQueryLoading'] = true;
        _this1.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: aiChatList
        });
        aiApi.lawQuery({
          count: 10,
          page: 1,
          query: content
        }).then(/*#__PURE__*/function () {
          var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref8) {
            var data;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.n) {
                case 0:
                  data = _ref8.data;
                  _context7.n = 1;
                  return _this1.loopSetLawQuery(aiChatList, 0, data);
                case 1:
                  resolve(data);
                case 2:
                  return _context7.a(2);
              }
            }, _callee7);
          }));
          return function (_x2) {
            return _ref9.apply(this, arguments);
          };
        }()).catch(function (error) {
          reject(error);
        });
      });
    },
    /**
     * 请求AI模型接口回答问题
     */
    getStreamMessage: function getStreamMessage(message, qLogId) {
      var _this10 = this;
      var conversationId = getSessionStorage('conversationId');
      var windowId = getSessionStorage('windowId');
      var params = {
        query: message,
        conversationId: conversationId,
        log: {
          windowId: windowId,
          qLogId: qLogId // 问题ID,重新生成的时候必填
        }
      };
      aiApi.sendMessage(params).then(function (response) {
        if (!response.ok) {
          throw new Error('Network response was not ok. ', JSON.stringify(response));
        }
        var reader = response.body.getReader(); // 使用response.body.getReader()来读取流
        _this10.readStreaming(reader, qLogId); // 开始读取
      }).catch(function (_) {
        _this10.$store.dispatch('ai/setValue', {
          key: 'aiLoading',
          value: false
        });
      });
    },
    /**
     * 保存问题的id及答案id
     */
    setQaLogId: function setQaLogId(_ref0) {
      var _this11 = this;
      var message_id = _ref0.message_id,
        task_id = _ref0.task_id;
      var aiChatList = _.cloneDeep(this.aiChatList);
      var index = aiChatList.findIndex(function (obj) {
        return obj.answer.id === _this11.qaId;
      });
      var lastAnswerIndex = aiChatList[index]['answer']['list'].length - 1;
      aiChatList[index]['answer']['list'][lastAnswerIndex].qLogId = message_id; // 保存问题ID
      aiChatList[index]['answer']['list'][lastAnswerIndex].aLogId = task_id; // 保存答案ID
      this.$store.dispatch('ai/setValue', {
        key: 'aiChatList',
        value: aiChatList
      });
    },
    /**
     * 设置思考工作流
     * @param dataObj = {}
     * @returns {Promise<any>}
     */
    setThinkingFlow: function setThinkingFlow(dataObj) {
      var _this12 = this;
      if (['error'].includes(dataObj.event)) {
        return this.$store.dispatch('ai/setValue', {
          key: 'aiLoading',
          value: false
        });
      }
      var _aiChatList = _.cloneDeep(this.aiChatList);
      var index = _aiChatList.findIndex(function (item) {
        return item.question.id === _this12.qaId;
      });
      if (index !== -1) {
        var lastAnswerIndex = _aiChatList[index]['answer']['list'].length;
        if (_aiChatList[index]['answer']['list'][lastAnswerIndex - 1].thinkingFlow.length === 0) {
          // 不存在思考流模板
          _aiChatList[index]['answer']['list'][lastAnswerIndex - 1].thinkingFlow = _.cloneDeep(this.thinkingFlowTemplate);
        } else {
          var _thinkingFlow = _aiChatList[index]['answer']['list'][lastAnswerIndex - 1].thinkingFlow;
          _aiChatList[index]['answer']['list'][lastAnswerIndex - 1].thinkingFlow = _thinkingFlow.map(function (item) {
            if (dataObj.data.title === item.title) {
              item.elapsedTime = dataObj.data.elapsed_time;
            }
            return item;
          });
        }
        return this.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: _aiChatList
        });
      }
    },
    /**
     * 读取流
     * @param reader
     * @param qLogId 问题日记ID
     */
    readStreaming: function readStreaming(reader, qLogId) {
      var _this13 = this;
      reader.read().then(function (_ref1) {
        var value = _ref1.value,
          done = _ref1.done;
        if (value) {
          // value是一个Uint8Array，需要转换为字符串
          var textDecoder = new TextDecoder('utf-8');
          var data = textDecoder.decode(value);
          var dataArr = data.split('data:');
          for (var index = 0; index < dataArr.length; index++) {
            var dataEle = dataArr[index];
            if (!dataEle) {
              continue;
            }
            var answer = '';
            var dataObj = {};

            // 获取答案文本
            var dataFormat = dataEle.replaceAll('data:', '').trim();
            if (isJsonString(dataFormat)) {
              // 正常json串
              dataObj = JSON.parse(dataFormat);
              answer = dataObj.answer;
              // 获取对话id
              setSessionStorage('conversationId', dataObj.conversation_id || '');
              done = dataObj.event === 'message_end'; // 获取对话是否结束

              _this13.setQaLogId(dataObj);
              if (['message', 'message_end'].includes(dataObj.event)) {
                // 处理数据
                _this13.getAnswer(answer, dataObj);
                // 回答结束，请求推荐文档
                if (dataObj.event === 'message_end') {
                  _this13.answerFinishTodo();
                }
              } else {
                // 思考工作流
                _this13.setThinkingFlow(dataObj);
              }
            } else {
              // 异常json串
              _this13.chunk.push(dataFormat);
              var jsonObj = _this13.chunk.join('');
              if (isJsonString(jsonObj)) {
                _this13.chunk = [];
                dataObj = JSON.parse(jsonObj);
                answer = dataObj.answer;
                _this13.setQaLogId(dataObj);
                if (['message', 'message_end'].includes(dataObj.event)) {
                  _this13.getAnswer(answer, dataObj);
                  // 回答结束，请求推荐文档
                  if (dataObj.event === 'message_end') {
                    _this13.answerFinishTodo();
                  }
                } else {
                  // 思考工作流
                  _this13.setThinkingFlow(dataObj);
                }
              }
            }
          }
        }
        if (done) {
          _this13.$store.dispatch('ai/setValue', {
            key: 'aiLoading',
            value: false
          });
        } else {
          _this13.readStreaming(reader, qLogId); // 继续读取
        }
      }).catch(console.error);
    },
    /**
     * 获取答案
     */
    getAnswer: function getAnswer(data, _ref10) {
      var _this14 = this;
      var message_id = _ref10.message_id,
        task_id = _ref10.task_id;
      var aiChatList = _.cloneDeep(this.aiChatList);
      // 思考开始
      if (data && data.includes('<think>')) {
        var _index = aiChatList.findIndex(function (obj) {
          return obj.answer.id === _this14.qaId;
        });
        if (_index !== -1) {
          var length = aiChatList[_index].answer.list.length;
          if (!aiChatList[_index].answer.list[length - 1].thinkStartTime) {
            aiChatList[_index].answer.list[length - 1].thinkStartTime = Date.now();
            this.$store.dispatch('ai/setValue', {
              key: 'aiChatList',
              value: aiChatList
            });
          }
        }
      }

      // 思考结束
      if (data && data.includes('</think>')) {
        var _index2 = aiChatList.findIndex(function (obj) {
          return obj.answer.id === _this14.qaId;
        });
        if (_index2 !== -1) {
          var _length = aiChatList[_index2].answer.list.length;
          if (!aiChatList[_index2].answer.list[_length - 1].thinkEndTime) {
            aiChatList[_index2].answer.list[_length - 1].thinkEndTime = Date.now();
            this.$store.dispatch('ai/setValue', {
              key: 'aiChatList',
              value: aiChatList
            });
          }
        }
      }
      var index = aiChatList.findIndex(function (obj) {
        return obj.answer.id === _this14.qaId;
      });
      if (index !== -1) {
        var _length2 = aiChatList[index].answer.list.length;
        var content = aiChatList[index].answer.list[_length2 - 1].content;
        if (data) {
          aiChatList[index].answer.list[_length2 - 1].content = content ? content.concat(data) : data;
          this.$store.dispatch('ai/setValue', {
            key: 'aiChatList',
            value: aiChatList
          });
        }
      }
    },
    /**
     * 停止回答
     */
    handleStop: function handleStop() {
      var _this15 = this;
      var chatIndex = this.aiChatList.findIndex(function (item) {
        return item.answer.id === _this15.qaId;
      });
      var lastAnswerIndex = this.aiChatList[chatIndex].answer['list'].length - 1;
      var answer = this.aiChatList[chatIndex].answer['list'][lastAnswerIndex];
      if (answer.aLogId) {
        aiApi.stopThinking(answer.aLogId).then(function (response) {
          if (!response.ok) {
            throw new Error('Network response was not ok. ', JSON.stringify(response));
          }
          _this15.$store.dispatch('ai/setValue', {
            key: 'aiLoading',
            value: false
          });
        }).catch(function (_) {
          _this15.$store.dispatch('ai/setValue', {
            key: 'aiLoading',
            value: true
          });
        });
      } else {
        _Toast('请稍后再试...');
      }
    },
    /**
     * 重新加载
     * @param chatIndex
     * @param answerIndex
     * @returns {ElMessageComponent}
     */
    reloadAnswer: function reloadAnswer(_ref11) {
      var _this16 = this;
      var chatIndex = _ref11.chatIndex,
        answerIndex = _ref11.answerIndex;
      if (this.aiLoading) {
        return this.$message.info('正在输出，请稍后再试...');
      }
      var aiChatList = _.cloneDeep(this.aiChatList);
      aiChatList[chatIndex].answer.list.push({
        aLogId: '',
        // 答案ID
        qLogId: '',
        // 问题ID
        content: '',
        // 内容
        help: 0,
        // 1无用,10有用,0初始状态
        windowId: '',
        conversationId: '',
        webQueryList: [],
        // 联网查询结果(博查)
        webQueryLoading: false,
        // 联网查询请求状态
        lawQueryList: [],
        // 法规查询结果
        LawQueryLoading: false,
        // 法规查询请求状态
        libraryQueryList: [],
        // 知识库查询结果 （目前没有实际业务,仅为占位）
        libraryQueryLoading: false,
        // 知识库查询请求状态
        thinkingFlow: [],
        // 思考工作流
        referDocList: [],
        // 推荐文档
        evaluate: 0 // 点赞、点踩
      });
      var _aiChatList$chatIndex = aiChatList[chatIndex].question,
        content = _aiChatList$chatIndex.content,
        id = _aiChatList$chatIndex.id;
      this.$store.dispatch('ai/setValue', {
        key: 'qaId',
        value: id
      });
      this.getWebQueryList(aiChatList, content).finally(function (_) {
        _this16.getLawQueryList(aiChatList, content).finally(function (_) {
          _this16.$store.dispatch('ai/setValue', {
            key: 'aiLoading',
            value: true
          });
          var qLogId = aiChatList[chatIndex].answer.list[answerIndex].qLogId; // 从答案中提取问题日记id
          _this16.getStreamMessage(content, qLogId);
        });
      });
    },
    /**
     * 回答关联的文档
     */
    getReferDoc: function getReferDoc(content) {
      var _this17 = this;
      var data = {
        answer: content
      };
      var aiChatList = _.cloneDeep(this.aiChatList);
      aiApi.getRecommendDoc(data).then(function (response) {
        var index = aiChatList.findIndex(function (chat) {
          return chat.answer.id === _this17.qaId;
        });
        var lastAnswerIndex = aiChatList[index].answer.list.length - 1;
        aiChatList[index].answer.list[lastAnswerIndex].referDocList = response.data; // 最后一条
        _this17.$store.dispatch('ai/setValue', {
          key: 'aiChatList',
          value: aiChatList
        });
      });
    },
    /**
     * AI回答结束后的处理
     * @param content
     * @param qLogId
     */
    answerFinishTodo: function answerFinishTodo() {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var aiChatList, index, lastAnswerIndex, answer;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              aiChatList = _.cloneDeep(_this18.aiChatList);
              index = aiChatList.findIndex(function (obj) {
                return obj.answer.id === _this18.qaId;
              }); // 答案
              lastAnswerIndex = aiChatList[index].answer.list.length - 1;
              answer = aiChatList[index].answer.list[lastAnswerIndex].content;
              _context8.n = 1;
              return _this18.getReferDoc(answer);
            case 1:
              _context8.n = 2;
              return _this18.handleGetRecommendLaw(answer);
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    /**
     * 法规详情
     * @param answer
     */
    handleGetRecommendLaw: function handleGetRecommendLaw(answer) {
      var _this19 = this;
      return new Promise(function (resolve, reject) {
        if (!answer) {
          resolve();
        }
        var html = md.render(md.render(answer));
        var data = {
          answer: html
        };
        var aiChatList = _.cloneDeep(_this19.aiChatList);
        getRecommendLaw(data).then(function (response) {
          var index = aiChatList.findIndex(function (chat) {
            return chat.answer.id === _this19.qaId;
          });
          var lastAnswerIndex = aiChatList[index].answer.list.length - 1;
          aiChatList[index].answer.list[lastAnswerIndex].recommendLawList = response.data; // 最后一条
          _this19.$store.dispatch('ai/setValue', {
            key: 'aiChatList',
            value: aiChatList
          });
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }
};